import Api from '@/apis/businessApi'
import Store from '@/store'
import i18n from '@/i18n'

export default {
  async getAll () {
    return Api()
      .get('/v1/admin/users')
      .then(async function (response) {
        return { success: true, value: response.data }
      })
      .catch(async function (error) {
        if (error.response.status === 400) {
          return { success: false, badRequestReasons: error.response.data }
        }
        await Store.dispatch('SetSnackBarMessage', {
          message: i18n.t('Services.Admin.User.Messages.LoadingUsersErrorMessage'),
          color: 'error',
        })
        console.log(error)
        return { success: false }
      })
  },
  async getByReseller (resellerId) {
    return Api()
      .get('/v1/admin/users/' + resellerId)
      .then(async function (response) {
        return { success: true, value: response.data }
      })
      .catch(async function (error) {
        if (error.response.status === 400) {
          return { success: false, badRequestReasons: error.response.data }
        }
        await Store.dispatch('SetSnackBarMessage', {
          message: i18n.t('Services.Admin.User.Messages.LoadingUserErrorMessage'),
          color: 'error',
        })
        console.log(error)
        return { success: false }
      })
  },
  async create (user) {
    return Api()
      .post('/v1/admin/users', {
        uid: '00000000-0000-0000-0000-000000000000',
        firstName: user.firstName,
        lastName: user.lastName,
        email: user.email,
        password: user.password,
        resellerUid: user.resellerUid || null,
        role: user.role,
      })
      .then(async function (response) {
        await Store.dispatch('SetSnackBarMessage', {
          message: i18n.t('Services.Admin.User.Messages.CreateUserSuccessMessage', [user.firstName, user.lastName]),
          color: 'success',
        })
        return { success: true, value: response.data }
      })
      .catch(async function (error) {
        if (error.response.status === 400) {
          return { success: false, badRequestReasons: error.response.data }
        }
        await Store.dispatch('SetSnackBarMessage', {
          message: i18n.t('Services.Admin.User.Messages.CreateUserErrorMessage', [user.firstName, user.lastName]),
          color: 'error',
        })
        console.log(error)
        return { success: false }
      })
  },

  async update (user) {
    var updatedUser = {
      uid: user.uid,
      firstName: user.firstName,
      lastName: user.lastName,
      email: user.email,
      resellerUid: user.resellerUid,
      role: user.role,
    }
    return Api()
      .put('/v1/admin/users', updatedUser)
      .then(function (response) {
        Store.dispatch('SetSnackBarMessage', {
          message: i18n.t('Services.Admin.User.Messages.UpdateUserSuccessMessage', [updatedUser.firstName, updatedUser.lastName]),
          color: 'success',
        })
        return { success: true, value: updatedUser }
      })
      .catch(function (error) {
        if (error.response.status === 400) {
          return { success: false, badRequestReasons: error.response.data }
        }
        Store.dispatch('SetSnackBarMessage', {
          message: i18n.t('Services.Admin.User.Messages.UpdateUserErrorMessage', [updatedUser.firstName, updatedUser.lastName]),
          color: 'error',
        })
        console.log(error)
        return { success: false }
      })
    },
}
